import { normalizeValue } from './ValueNormalizer';

export const TireSize = [
  '9',
  '9.5',
  '10',
  '10.5',
  '10R17.5',
  '10R22.5',
  '10R24.5',
  '11',
  '11.5',
  '11R17.5',
  '11R22.5',
  '11R24.5',
  '12',
  '12.5',
  '12R17.5',
  '12R22.5',
  '12R24.5',
  '13',
  '13.5',
  '14',
  '14.5',
  '15',
  '15.5',
  '16',
  '16.5',
  '17',
  '17.5',
  '18',
  '18.5',
  '19',
  '215',
  '215/75R17.5',
  '225/70R19.5',
  '235',
  '235/75R17.5',
  '245',
  '245/70R17.5',
  '245/70R18.5',
  '245/70R19.5',
  '245/70R22.5',
  '255',
  '255/70R22.5',
  '265/70R19.5',
  '265/75R22.5',
  '275',
  '275/70R22.5',
  '275/80R22.5',
  '279',
  '280',
  '285/75R22.5',
  '285/75R24.5',
  '295',
  '295/75R22.5',
  '305',
  '315',
  '315/80R22.5',
  '325',
  '330',
  '335',
  '360',
  '369',
  '385',
  '385/65R22.5',
  '385/85R22.5',
  '395',
  '410',
  '425',
  '425/85R22.5',
  '435',
  '445/455',
  '445/85R22.5',
  '465',
  '475',
  '485',
] as const;

export const normalizeTireSize = (size?: string | null): string | undefined => {
  return normalizeValue(TireSize, size);
};
